export enum FeedbackSubjectEnum {
  subject = 'Feedback - Edge Invoicing',
};
